import {createSlice, PayloadAction } from '@reduxjs/toolkit';
import { type RootState } from '../../store';
import { AccountInfo, EventMessageUtils } from '@azure/msal-browser';
import axios from 'axios';
import IConnection from '../../interfaces/connection.interface';
import dayjs from 'dayjs';

// Define a type for the slice state
export interface ConnectionState {
  connection: IConnection
}

// Define the initial state using that type
const initialState: ConnectionState = {
    connection: {status:"", timestamp:""},
}

export const ConnectionSlice = createSlice({
  name: 'Connection',
  initialState,
  reducers: {
    checkConnection: (state, action: PayloadAction<string>)=>{
      //TODO
      state.connection.status = "Connected";
    },
    
  },
});
    

export const { checkConnection} = ConnectionSlice.actions


export default ConnectionSlice.reducer